import { Input } from './input'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/number-input.ts
export const NumberInput = {
  variants: Input.variants,
  sizes: {
    md: {
      field: Input.sizes.md.field,
    },
  },
}
